// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.visit-card {
  display: flex;
  flex-direction: column;
  margin: 20px;
  border-radius: 12px;
  overflow: hidden;
  animation: glow-border 0.7s infinite alternate; /* Agregar animación de parpadeo al borde */
}
.visit-card .white-chip {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.87);
}
.visit-card .white-chip ion-icon {
  color: rgba(255, 255, 255, 0.87);
}
.visit-card-header {
  z-index: 1001;
  margin-bottom: -60px;
  padding: 10px;
  background: linear-gradient(to top, transparent, rgba(0, 0, 0, 0.3));
  display: flex;
  flex-direction: row-reverse;
}
.visit-card-footer {
  z-index: 1001;
  margin-top: -52px;
  padding: 10px;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.6));
}
.visit-card-footer-connection {
  display: flex;
  flex-direction: row;
}
.visit-card-footer-connection-userPhoto > ion-chip {
  margin: 0;
}
.visit-card-footer-connection-visitMessage {
  color: rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.87);
  padding: 8px;
  font-size: 14px;
}
.visit-card-footer-connection-mirPhoto > ion-chip {
  margin: 0;
}

.app-image-shell.friend-picture {
  --image-shell-border-radius: var(--page-border-radius);
}

.loading-shell {
  width: 100%;
  height: 0;
  padding-bottom: 125%; /* Para crear un contenedor cuadrado */
  background-color: #f5f5f5; /* Color de fondo del shell */
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading {
  width: 100%;
  height: 100%;
  background-color: #ccc; /* Color gris para el efecto de carga */
  opacity: 0.4; /* Opacidad para el efecto de carga */
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.loaded {
  opacity: 1; /* Mostrar la imagen cuando esté cargada */
  transition: opacity 0.3s ease-in-out;
}

@keyframes glow-border {
  0% {
    border: 2px solid rgba(66, 140, 255, 0.5); /* Color y grosor del borde en el estado inicial */
  }
  100% {
    border: 2px solid rgba(66, 140, 255, 0.8); /* Color y grosor del borde en el estado final */
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/posts/new-visit-experience/new-visit-experience.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,8CAAA,EAAA,2CAAA;AAEF;AAAE;EACI,qCAAA;EACA,gCAAA;AAEN;AACE;EACI,gCAAA;AACN;AAEE;EACI,aAAA;EACA,oBAAA;EACA,aAAA;EACA,oEAAA;EACA,aAAA;EACA,2BAAA;AAAN;AAGE;EACI,aAAA;EACA,iBAAA;EACA,aAAA;EACA,uEAAA;AADN;AAGM;EACI,aAAA;EACA,mBAAA;AADV;AAIc;EACI,SAAA;AAFlB;AAMU;EACI,qDAAA;EACA,YAAA;EACA,eAAA;AAJd;AAQc;EACI,SAAA;AANlB;;AAaA;EACE,sDAAA;AAVF;;AAaA;EACE,WAAA;EACA,SAAA;EACA,oBAAA,EAAA,sCAAA;EACA,yBAAA,EAAA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,sBAAA,EAAA,uCAAA;EACA,YAAA,EAAA,qCAAA;EACA,8BAAA;AAVF;;AAaA;EACE;IACI,UAAA;EAVJ;EAYA;IACI,YAAA;EAVJ;EAYA;IACI,UAAA;EAVJ;AACF;AAaA;EACE,UAAA,EAAA,0CAAA;EACA,oCAAA;AAXF;;AAcA;EACE;IACE,yCAAA,EAAA,kDAAA;EAXF;EAaA;IACE,yCAAA,EAAA,gDAAA;EAXF;AACF","sourcesContent":[".visit-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 20px;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  animation: glow-border 0.7s infinite alternate; /* Agregar animación de parpadeo al borde */\r\n\r\n  .white-chip {\r\n      background: rgba(white, 0.12);\r\n      color: rgba(white, 0.87);\r\n  }\r\n\r\n  .white-chip ion-icon {\r\n      color: rgba(white, 0.87);\r\n  }\r\n\r\n  &-header {\r\n      z-index: 1001;\r\n      margin-bottom: -60px;\r\n      padding: 10px;\r\n      background: linear-gradient(to top, transparent, rgba(0, 0, 0, 0.3));\r\n      display: flex;\r\n      flex-direction: row-reverse;\r\n  }\r\n\r\n  &-footer {\r\n      z-index: 1001;\r\n      margin-top: -52px;\r\n      padding: 10px;\r\n      background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.6));\r\n\r\n      &-connection {\r\n          display: flex;\r\n          flex-direction: row;\r\n\r\n          &-userPhoto {\r\n              > ion-chip {\r\n                  margin: 0;\r\n              }\r\n          }\r\n\r\n          &-visitMessage {\r\n              color: rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.87);\r\n              padding: 8px;\r\n              font-size: 14px;\r\n          }\r\n\r\n          &-mirPhoto {\r\n              > ion-chip {\r\n                  margin: 0;\r\n              }\r\n          }\r\n      }\r\n  }\r\n}\r\n\r\n.app-image-shell.friend-picture {\r\n  --image-shell-border-radius: var(--page-border-radius);\r\n}\r\n\r\n.loading-shell {\r\n  width: 100%;\r\n  height: 0;\r\n  padding-bottom: 125%; /* Para crear un contenedor cuadrado */\r\n  background-color: #f5f5f5; /* Color de fondo del shell */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.loading {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #ccc; /* Color gris para el efecto de carga */\r\n  opacity: 0.4; /* Opacidad para el efecto de carga */\r\n  animation: pulse 1.5s infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n      opacity: 1;\r\n  }\r\n  50% {\r\n      opacity: 0.4;\r\n  }\r\n  100% {\r\n      opacity: 1;\r\n  }\r\n}\r\n\r\n.loaded {\r\n  opacity: 1; /* Mostrar la imagen cuando esté cargada */\r\n  transition: opacity 0.3s ease-in-out;\r\n}\r\n\r\n@keyframes glow-border {\r\n  0% {\r\n    border: 2px solid rgba(66, 140, 255, 0.5); /* Color y grosor del borde en el estado inicial */\r\n  }\r\n  100% {\r\n    border: 2px solid rgba(66, 140, 255, 0.8); /* Color y grosor del borde en el estado final */\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
